export const iconFontAwesomeDisasterCrisisWind = (
	<i className="fa-solid fa-wind"></i>
);
